import { useCallback, useId } from 'react';

import { UseDrawerAccessibilityArgs } from '../drawer.types';

export const useDrawerAccessibility = ({
  hasBackdrop,
  hasBody,
  isOpen,
  onClose,
  titleId,
  headerTitle,
}: UseDrawerAccessibilityArgs) => {
  const bodyId = useId();

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLElement>) => {
      if (!isOpen || hasBackdrop || event.key !== 'Escape') return;

      event.preventDefault();
      event.stopPropagation();
      onClose(event);
    },
    [hasBackdrop, isOpen, onClose],
  );

  return {
    bodyId,
    titleId,
    dialogProps: {
      'aria-label': headerTitle,
      'aria-labelledby': headerTitle ? titleId : undefined,
      'aria-modal': hasBackdrop ? isOpen : undefined,
      'aria-hidden': !isOpen,
      'aria-describedby': hasBody ? bodyId : undefined,
      tabIndex: isOpen ? -1 : undefined,
      onKeyDown: handleKeyDown,
    },
  };
};
